import { z } from "zod";
import { DateTime } from "luxon";

const FileVariantResponseSchema = z.object({
  id: z.string(),
  variant_type: z.string(),
});

/**
 * One file in a retention scope, from the File API's
 * `GET /api/v1/scopes/{scope_id}/files/variants`. Parsing keeps the fields the
 * UI reads. `variants` takes the shape of `FileMessageMeta.variants`, so the
 * same permalink helpers serve the file explorer and `MessageFile`.
 */
const ScopeFileResponseSchema = z
  .object({
    id: z.string(),
    original_filename: z.string(),
    created_at: z.string(),
    variants: z.array(FileVariantResponseSchema),
  })
  .transform((file) => ({
    fileId: file.id,
    filename: file.original_filename,
    createdAt: DateTime.fromISO(file.created_at),
    variants: file.variants.map((variant) => ({
      variant_id: variant.id,
      variant_type: variant.variant_type,
    })),
  }));

export const ScopeFilesResponseSchema = z.array(ScopeFileResponseSchema);

export type ScopeFile = z.output<typeof ScopeFileResponseSchema>;
